import { useTranslations } from '@npco/utils-translations'
import {
  InfoBox,
  INFOBOX_PRIORITY,
  INFOBOX_VARIANT,
  Label,
} from '@npco/zeller-design-system'

import { currencyFormatter } from 'utils/common'
import {
  StyledTransferAmount as Amount,
  StyledTransferDetails as Details,
  StyledTransferSummaryRow as SummaryRow,
  StyledTransferValue as Value,
} from 'pages/Transfer/states/TransferSummary/TransferSummary.styled'
import { useTransferState } from 'pages/Transfer/Transfer.context'
import { zellerTransferTranslations } from 'pages/Transfer/Transfer.i18n'
import { TransferBpayFields } from 'pages/Transfer/Transfer.types'

import { TransferStateCondition } from '../states/TransferState/TransferStateCondition'
import {
  TransferBpayState,
  TransferGeneralState,
} from '../Transfer.stateMachine'
import { translations } from './BpaySummary.i18n'

export const BpaySummary = () => {
  const t = useTranslations(translations)
  const tZellerTransfer = useTranslations(zellerTransferTranslations)
  const transferState = useTransferState().transferValues as TransferBpayFields
  const { amount, crn, nickname, to, paymentInstrumentUuid } = transferState

  const billerDetail = to?.billerContacts?.find(
    (item) => item.id === paymentInstrumentUuid?.id
  )

  return (
    <Details>
      <SummaryRow>
        <Label>{t('nickname')}</Label>
        <Value>{nickname ?? billerDetail?.nickname}</Value>
      </SummaryRow>
      <SummaryRow>
        <Label>{t('billerCode')}</Label>
        <Value>{to?.code ?? billerDetail?.code}</Value>
      </SummaryRow>
      <SummaryRow>
        <Label>{t('billerName')}</Label>
        <Label>{billerDetail?.name ?? to?.name}</Label>
      </SummaryRow>
      <SummaryRow>
        <Label>{t('crn')}</Label>
        <Value>{crn ?? billerDetail?.reference}</Value>
      </SummaryRow>
      <SummaryRow>
        <Label>{tZellerTransfer('amountLabel')}</Label>
        <Amount>{currencyFormatter(+amount * 100)}</Amount>
      </SummaryRow>
      <TransferStateCondition
        parent={TransferGeneralState.BpayTransfer}
        allowedStates={[TransferBpayState.Summary, TransferBpayState.Sending]}
      >
        <InfoBox
          priority={INFOBOX_PRIORITY.MEDIUM}
          variant={INFOBOX_VARIANT.POSITIVE}
        >
          <InfoBox.Message>{t('info')}</InfoBox.Message>
        </InfoBox>
      </TransferStateCondition>
    </Details>
  )
}
